<h1>
  {{header}}
</h1>
<div *ngIf="content; else iframe" class="content" [innerHtml]="content">
</div>
<ng-template #iframe>
  <div class="content">
    <iframe [src]="iframeUrl"></iframe>
  </div>
</ng-template>